
import React, { useState } from "react";
import { MapPin } from "lucide-react";

interface CardImageProps {
  nhSlug: string;
  centerName: string;
  address?: string;
}

export function CardImage({ nhSlug, centerName, address }: CardImageProps) {
  const [imgError, setImgError] = useState(false);

  const generateBackgroundColor = (name: string) => {
    const colors = [
      "bg-grandpal-beige",
      "bg-grandpal-green-lighter",
      "bg-gray-100",
      "bg-stone-100",
      "bg-emerald-50",
      "bg-slate-100",
      "bg-zinc-100",
    ];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  // For listing cards, show a simple branded placeholder with address instead of a map
  return (
    <div className={`w-full h-48 flex items-center justify-center ${generateBackgroundColor(centerName || '')}`}>
      <div className="text-center p-4">
        <MapPin className="h-10 w-10 text-primary mx-auto mb-2" aria-hidden="true" />
        <p className="text-primary font-medium line-clamp-2">{centerName || "Nursing Home"}</p>
        {address && (
          <p className="text-muted-foreground text-sm mt-1 line-clamp-2">{address}</p>
        )}
      </div>
    </div>
  );
}
